import FiltersLoadingSkeleton from 'components/molecules/FiltersLoadingSkeleton';
import HeaderLoadingSkeleton from 'components/molecules/HeaderLoadingSkeleton';
import ListLoadingSkeleton from 'components/molecules/ListLoadingSkeleton';
import TabsLoadingSkeleton from 'components/molecules/TabsLoadingSkeleton';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { documentsTableSkeletonColumns } from './skeletons';

const DocumentsRepositoryLoadingSkeleton: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderLoadingSkeleton title="Documents repository" />
      <FiltersLoadingSkeleton />
      <TabsLoadingSkeleton />
      <ListLoadingSkeleton columns={documentsTableSkeletonColumns} />
    </>
  );
};

export default DocumentsRepositoryLoadingSkeleton;
